module.exports = "/out/e079e5837ab05e094a306564e81d2c31.svg";